import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { apiEnvironment } from "@kells/clinic-one/environments";
import { VirtualCheckupHandoffService } from "../virtual-checkup-handoff/virtual-checkup-handoff.service";
import { IntegratedAuthService } from "../auth";

/**
 * When the handoff token expires or is revoked, clear client state so the UI
 * can redirect to login instead of failing silently on every API call.
 */
@Injectable()
export class VirtualCheckupHandoffAuthErrorInterceptor implements HttpInterceptor {
  constructor(
    private readonly handoff: VirtualCheckupHandoffService,
    private readonly auth: IntegratedAuthService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (
          err.status === 401 &&
          request.url.startsWith(apiEnvironment.apiBaseUrl) &&
          this.handoff.isActive()
        ) {
          this.auth.endVirtualCheckupHandoffSession();
        }
        return throwError(err);
      })
    );
  }
}
